/* eslint-disable max-len */

export const text = [
  `Из-за прекращения охот в Царском селе павильон и окрестности пришли в негодность, поэтому из царской казны было выделено больше 60 тысяч рублей на починку Монбижу и дорог, ведущих к нему.`,
  `По решению Александра первого все работы были прекращены, к 1819 году павильон был разобран до основания.`]
;
